export default {
    name: "Disable",
    title: "Disable",
    icon: "mdi-cancel",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};